<template>
  <div class="marketplace-checkout--shipping-addresses">
    <div
      v-if="shippingAddresses.length > 0"
      v-for="(shippingAddress, index) in shippingAddresses"
      :key="`shipping-address-${index}`"
      :class="{
        'marketplace-checkout--shipping-addresses--address': true,
        'checked': isShippingAddressChecked(shippingAddress)
      }"
    >
      <h3 class="text-base fw-strong">{{ 'Address' | t }} {{ index + 1 }} <span v-if="shippingAddress.defaultAddress">({{ 'default' | t }})</span></h3>
      <SloIcon name="CircleCheckSolid" />
      <input
        :id="`shipping-address-${index}`"
        type="radio"
        :value="shippingAddress.id"
        :checked="isShippingAddressChecked(shippingAddress)"
        @input="$emit('selectAddress', shippingAddress.id)"
      />
      <label :for="`shipping-address-${index}`">
        <span>{{ shippingAddress.firstName }}</span>
        <span v-if="shippingAddress.attention">
          ATTN: {{ shippingAddress.attention }}
        </span>
        <span v-if="shippingAddress.companyName">
          {{ shippingAddress.companyName }}
        </span>
        <span>{{ shippingAddress.line1 }}, {{ shippingAddress.line2 }}
        </span>
        <span>
          {{ shippingAddress.town }},
          {{ shippingAddress.region?.isocode }},
          {{ shippingAddress.country?.isocode }},
          {{ shippingAddress.postalCode }}
        </span>
        <span>{{ shippingAddress?.phone }}</span>
      </label>
      <div class="flex items-center flex-wrap gap-md">
        <SloButton
          v-if="showModifyControls && !shippingAddress.isDisposable"
          @click="$emit('updateAddress', shippingAddress.id)"
          fill="clear"
          class="px-0 py-sm bg-transparent text-sm c-blue-400 fw-strong hover:c-blue-700"
        >
          {{ 'Update' | t }}
        </SloButton>
        <SloButton
          v-if="showModifyControls && showRemoveAddress"
          @click="$emit('removeAddress', shippingAddress.id)"
          fill="clear"
          class="px-0 py-sm bg-transparent text-sm c-blue-400 fw-strong hover:c-blue-700"
        >
          {{ 'Remove' | t }}
        </SloButton>
        <SloButton
          v-if="showModifyControls && !shippingAddress.defaultAddress"
          @click="$emit('makeAddressDefault', shippingAddress)"
          size="small"
          fill="outline"
        >
          {{ 'Make Default' | t }}
        </SloButton>
      </div>
    </div>
  </div>
</template>

<script>
import t from '../../main/i18n';
import SloIcon from '../../../lib/components/SloIcon.vue';
import SloButton from '../../../lib/components/SloButton.vue';

export default {
  name: 'ShippingAddresses',
  components: {
    SloIcon,
    SloButton
  },
  filters: {
    t
  },
  props: {
    showModifyControls: {type: Boolean, default: false},
    shippingAddresses: {type: Array, required: true},
    shippingAddressId: {type: String, default: ''},
    showRemoveAddress: {type: Boolean, default: true}
  },
  methods: {
    isShippingAddressChecked(address) {
      if (this.shippingAddressId === address.id) return true;
      if (!this.shippingAddressId === address.id && address.defaultAddress) return true;
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.marketplace-checkout--shipping-addresses {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(215px, 1fr));
  grid-gap: 1.6rem;
  margin-bottom: 3.2rem;

  &--address {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 0.8rem;
    padding: 1.6rem;
    border: 1px solid $color-gray-400;
    border-radius: 0.8rem;
    transition: border-color 0.15s ease-in, box-shadow 0.15s ease-in;

    &:hover, &:focus-within {
      border-color: $color-gray-600;
    }

    &.checked {
      box-shadow: inset 0 0 0 1px $color-blue-400;
      border-color: $color-blue-400;

      h3 {
        color: $color-blue-400;
      }

      .slo-icon {
        opacity: 1;
        scale: 1;
      }
    }

    h3 {
      color: $color-gray-900;
      transition: color 0.15s ease-in;
    }

    .slo-icon {
      position: absolute;
      top: 1.6rem;
      right: 1.6rem;
      color: $color-blue-400;
      opacity: 0;
      scale: 0.6;
      transition: opacity 0.15s ease-in, scale 0.15s ease-in;
    }

    input {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      opacity: 0;
      cursor: pointer;
    }

    label {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: start;
      color: $color-gray-700;
      font-size: 1.4rem;
      font-weight: 400;
    }

    button {
      position: relative;
      z-index: 10;
    }

    span {
      word-break: break-word;
    }
  }
}
</style>
